




















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { ISchool } from '@/models/School';

@Component
export default class AdminSchool extends Vue {
  @Prop() school!: ISchool;
  @Prop() isOpen!: boolean;
  public isExpanded = this.isOpen;

  @Watch('isOpen')
  changeIsOpen() {
    this.isExpanded = this.isOpen;
  }
}
